import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NavigatableComponent, Side } from 'src/navigatableComponent';

@Component({
    selector: "application-tile",
    templateUrl: "application-tile.component.html"
})
export class ApplicationTileComponent extends NavigatableComponent {

    @Input('application')
    application: tizen.ApplicationInformation;

    public hasTakenFocus: boolean = false;
    @Input('takeFocus')
    set takeFocus(v: boolean) {

        if(v !== this.hasTakenFocus) {

            this.hasTakenFocus = v;
            if(v) {
                console.log(`ApplicationTileComponent ${this.application.id} takeFocus(${v}). Taking focus`);
                this.focus("Unknown");
            } else {
                console.log(`ApplicationTileComponent ${this.application.id} takeFocus(${v}). Relinquish focus`);
                this.relinquishFocus("Unknown");
            }
        }
    }

    get takeFocus() : boolean {
        return this.hasTakenFocus;
    }

    focus(from: Side) {
        console.log('applicationtile focus invoked');
        super.focus(from);
        if(this.applicationHyperlink && this.applicationHyperlink.nativeElement) {
            this.applicationHyperlink.nativeElement.focus();
        }
    }

    @ViewChild('hyperlink') applicationHyperlink : ElementRef;
}